module.exports = __webpack_public_path__ + "static/media/seeds-of-life-mobile.6e45b74b.jpg";